import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/projects/components/ui/dialog";
import { Button } from "@/projects/components/ui/button";
import { Download } from "lucide-react";
import type { Submission } from "@/projects/lib/store";

export function VideoPlayerModal({
  submission,
  open,
  onOpenChange,
}: {
  submission: Submission | null;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{submission?.videoTitle ?? "Video"}</DialogTitle>
        </DialogHeader>
        <div className="aspect-video overflow-hidden rounded-lg bg-black">
          {submission?.videoUrl ? (
            <video
              key={submission.videoUrl}
              controls
              className="h-full w-full"
              src={submission.videoUrl}
            />
          ) : (
            <div className="text-muted-foreground grid h-full place-items-center text-sm">
              No video URL available for this submission.
            </div>
          )}
        </div>
        {submission && (
          <div className="text-muted-foreground mt-2 flex flex-wrap items-center justify-between gap-3 text-sm">
            <div>
              <div className="text-foreground font-medium">
                {submission.fileName}
              </div>
              <div>{submission.fileSizeMB} MB</div>
            </div>
            {submission.videoUrl ? (
              <Button variant="outline" size="sm" asChild>
                <a href={submission.videoUrl} download={submission.fileName}>
                  <Download className="mr-2 h-4 w-4" /> Download
                </a>
              </Button>
            ) : (
              <Button variant="outline" size="sm" disabled>
                <Download className="mr-2 h-4 w-4" /> Download
              </Button>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
